import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { HcrService } from 'src/app/services/hcr-service.service';
import { FnKey, HotKeyService, Priority } from 'src/app/services/hotkey-service';

@Component({
  selector: 'app-qrcode-scanner',
  templateUrl: './qrcode-scanner.component.html',
  styleUrls: ['./qrcode-scanner.component.scss']
})
export class QrcodeScannerComponent implements OnInit,OnDestroy {

  @Output()
  onSuccess:EventEmitter<string> = new EventEmitter();
  constructor(private hcrService:HcrService,private hk:HotKeyService,
    private ele:ElementRef<HTMLElement>,
    private notify:EasyNotificationService
  ) { }
  _camera: MediaDeviceInfo;
  scanEnable = false;
  result = '';
  href = '';
  messageBody = '';
  set activeCamera(value: MediaDeviceInfo){
    this._camera = value;
    if(value){
      this.scanEnable = true;
    }
  }
  get activeCamera(): MediaDeviceInfo{
    return this._camera;
  }
  fnId = 0;
  ngOnInit(): void {
    //window.location.href= 'sms:1922?body=1234';
    //window.addEventListener('keypress',this.onkeydown);
    this.fnId = this.hk.regist(Priority.Hight,'Fn',this.onkeydown.bind(this))
  }
  ngOnDestroy(): void {
    if(this.fnId){
      this.hk.unRegist(this.fnId);
    }
  }
  async onkeydown(k:FnKey){
    if(k=='F1'){
      var ret = await this.hcrService.SendFromUrl('https://medvpndct.nhi.gov.tw/test/v1/VirtualHc/Generate',
        JSON.stringify({
          "cardId": "990080000037",
          "birthday": "0760612",
          "hasPin": false,
          "verifiedPin": false
        }),'application/json','uft8',{}
      )
      var s = JSON.parse(ret.Returns) as { statusCode:number,qrCode:string};
      if(s.statusCode==0){
        this.scanSuccessed(s.qrCode)  
      }else{
        this.notify.showError(s.statusCode);
      }
    }
    //window.removeEventListener('keypress',this.onkeydown)
    this.hk.unRegist(this.fnId);
  }
  scanSuccessed(data: string)
  {
    this.result =data
    console.log(data)
    this.onSuccess.emit(data);
    this.scanEnable = false;
  }
  isIos():boolean{
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

}
